import { extensions } from '../../extensions/Extensions';
import { TilingSpritePipe } from './TilingSpritePipe';

extensions.add(TilingSpritePipe);
